import React from 'react';
import styles from './failed-payment.module.css';
import '../../payments.css';
import iconoReintentar from '../../assets/icono-boton-reintentar.png';
import iconoDisclaimer from '../../assets/icono-disclaimer.png';

export const FailedPayment = ({ 
  errorMessage = 'No pudimos procesar tu pago',
  errorDetails = 'Revisa la información de tu tarjeta',
  errorCode = '2007',
  errorDescription = 'El número de tarjeta no es correcto.',
  onRetry,
}) => {

  return (
    <div className={styles.container}>
      <div className={styles.errorContainer}>
        <div className={styles.errorHeader}>
          <img
            src={iconoDisclaimer}
            alt="Advertencia"
            className={styles.warningIcon}
          />
          <h3 className={styles.errorTitle}>{errorMessage}</h3>
        </div>
        <div className={styles.errorContent}>
          <p className={styles.errorText}>{errorDetails}</p>
          <p className={styles.errorCode}>
            Error: <strong>{errorCode}</strong> - {errorDescription}
          </p>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <button
          type="button"
          className="payment-button"
          onClick={onRetry}
        >
          Intentar de nuevo
          <img
            src={iconoReintentar}
            alt="Reintentar"
            className={styles.buttonIcon}
          />
        </button>
      </div>
    </div>
  );
};
